export default "__VITE_ASSET__a1cba79f__"